<template>
  <div class="product-center">
    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('productCenter.bannerTitle') }}
          <span></span>
        </div>
      </div>
    </div>
    <div v-if="$route.path === '/productCenter'" class="content">
      <div class="content-title">
        <div class="title">{{ $t('productCenter.title') }}</div>
        <span></span>
      </div>
      <div 
        class="product-item" 
        v-for="(item, index) in productList" 
        :key="item.id"
        :style="`background-image: url(${item.url})`"
      >
        <div 
          class="product-item-info" 
          :style="(index + 1) % 2 ? `float:right;` : `float:left;`"
        >
          <div class="title">{{ item.name }}</div>
          <span class="line"></span>
          <div class="info">{{ item.content }}</div>
          <div class="more" @click="toProductInfo">
            <span>{{ $t('productCenter.more') }}</span>
            <span class="arrow">></span>
          </div>
        </div>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script> 
// import product1 from './components/product1.vue'
export default {
  data () {
    return {
      bannerUrl2: require('@/assets/images/productCenter/banner2.png'),
      bannerUrl1: require('@/assets/images/productCenter/banner1.png'),
      tabsList: [
        { label: '纳米隔热板', value: '1' },
        { label: '气凝胶简介', value: '2' },
        { label: '导热界面材料（TIM）', value: '3' },
      ],
      currentIndex: '1'
    }
  },
  computed: {
    bannerUrl () {
      return this.$route.path === '/productCenter' ? this.bannerUrl2 : this.bannerUrl1
    },
    productList() {
      return [
        { 
          name: this.$t('productCenter.products.heatConduction.name'), 
          url: require('@/assets/images/productCenter/productHome1.png'), 
          content: this.$t('productCenter.products.heatConduction.content'), 
          id: '1'
        },
        { 
          name: this.$t('productCenter.products.nanoBoard.name'), 
          url: require('@/assets/images/productCenter/productHome2.png'), 
          content: this.$t('productCenter.products.nanoBoard.content'), 
          id: '2'
        },
        { 
          name: this.$t('productCenter.products.thermalInsulation.name'), 
          url: require('@/assets/images/productCenter/productHome3.png'), 
          content: this.$t('productCenter.products.thermalInsulation.content'), 
          id: '3'
        },
        { 
          name: this.$t('productCenter.products.fireproof.name'), 
          url: require('@/assets/images/productCenter/productHome4.png'), 
          content: this.$t('productCenter.products.fireproof.content'), 
          id: '4'
        },
        { 
          name: this.$t('productCenter.products.heatInsulation.name'), 
          url: require('@/assets/images/productCenter/productHome5.png'), 
          content: this.$t('productCenter.products.heatInsulation.content'), 
          id: '5'
        },
        { 
          name: this.$t('productCenter.products.electricHeating.name'), 
          url: require('@/assets/images/productCenter/productHome6.png'), 
          content: this.$t('productCenter.products.electricHeating.content'), 
          id: '6'
        },
        { 
          name: this.$t('productCenter.products.dielectric.name'), 
          url: require('@/assets/images/productCenter/productHome7.png'), 
          content: this.$t('productCenter.products.dielectric.content'), 
          id: '7'
        },
        { 
          name: this.$t('productCenter.products.electricConduction.name'), 
          url: require('@/assets/images/productCenter/productHome8.png'), 
          content: this.$t('productCenter.products.electricConduction.content'), 
          id: '8'
        }
      ]
    }
  },
  methods: {
    tabClick (value) {
      this.currentIndex = value
    },
    toProductInfo () {
      
      this.$router.push('/productCenter/productInfo')
      document.querySelector('body').scroll(0, 650)
    }
  },
  components: {
    // product1
  }
}
</script>

<style scoped lang="scss">
.product-center {
  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    background-position: top center;
    background-repeat: no-repeat;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 354px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 56px;
    .content-title {
      padding-top: 100px;
      padding-bottom: 60px;
      .title {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
      }
      span {
        display: block;
        margin-top: 16px;
        width: 80px;
        height: 4px;
        background: rgba(28, 100, 215, 1);
      }
    }
    .product-item {
      width: 1200px;
      height: 338px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 44px;
      .product-item-info {
        width: 600px;
        height: 100%;
        box-sizing: border-box;
        padding: 40px 30px;
        transition: all .2s ease-in-out;
        background: rgba(34, 34, 34, 0.6);
        backdrop-filter: blur(20px);
        &:hover {
          width: 800px;
          background-color: rgba(28, 100, 215, 1);
        }
        .title {
          font-weight: 500;
          font-size: 36px;
          line-height: 50px;
          color: #fff;
        }
        .line {
          width: 80px;
          height: 4px;
          background-color: #fff;
          display: inline-block;
          margin-top: 16px;
          margin-bottom: 24px;
        }
        .info {
          width: 100%;
          height: 110px;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: #fff;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;    /* 限制5行 */
          overflow: hidden;
          text-overflow: ellipsis;  /* 可选，但配合使用效果更好 */
          word-break: break-word;   /* 防止长单词溢出 */
          
          
        }
        .more {
          padding-top: 24px;
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: #fff;
          cursor: pointer;
          .arrow {
            padding-left: 10px;
          }
        } 
      }
    }
  }
  // .content-tabs {
  //   padding: 45px 0;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   background: rgba(249, 249, 249, 1);
  //   .content-tabs-item {
  //     padding: 14px 32px;
  //     color: #333;
  //     border-radius: 32px 32px 32px 32px;
  //     background-color: rgb(240, 240, 240);
  //     margin: 0 8px;
  //     cursor: pointer;
  //     &.current {
  //       color: #fff;
  //       background-color: rgb(28, 100, 215);
  //     }
  //   }
  // }
  // .content {
  //   width: 1200px;
  //   margin: 0 auto;
  //   .tabs-content {
  //     padding-top: 100px;
  //   }
  // }
}
</style>